export enum PermissionsEnum {
  create = 'CREATE',
  delete = 'DELETE',
  read = 'READ',
  update = 'UPDATE',
}
